import React, { useEffect, useState, useMemo } from 'react';
import maplibregl from 'maplibre-gl';
import MapGL, { Source, Layer } from 'react-map-gl';
import { heatmapLayer, heatmapLayerPoints, heatMapStyle } from './map-style';
import { handleUserSession } from '../../actions';
import { CircularProgress } from '@material-ui/core';
import { urlTracking } from '../../constants/api_urls';

const HeatMap = ({ appName }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const token = await handleUserSession();

    if (token) {
      const myHeaders = new Headers({
        'Content-Type': 'application/json',
        authorization: 'Bearer ' + token.getJwtToken(),
        'X-Api-Key': token.decodePayload().apiKey
      });
      const init = {
        method: 'get',
        headers: myHeaders
      };
      await fetch(`${urlTracking}/${appName}`, init)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          setLoading(false);
        }).catch((error) => {
          console.log('error', error);
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const dataMemo = useMemo(() => {
    if (!data) {
      return null;
    } else {
      const { items } = data;
      return {
        type: 'FeatureCollection',
        features: items.map(item => {
          const { coordinates, id, appName, createdAt } = item;
          return {
            geometry: {
              type: 'Point',
              coordinates
            },
            properties: {
              appName: appName,
              id: id,
              time: createdAt
            },
            type: 'Feature'
          };
        })
      };
    }
  }, [data]);

  return (
    <MapGL
      onError={(error) => console.log('error', error)}
      projection='globe'
      mapLib={maplibregl}
      initialViewState={{
        longitude: 0,
        latitude: 0,
        zoom: 2
      }}
      style={{
        width: '100%',
        height: 'calc(100vh)',
        opacity: loading ? 0.5 : 1
      }}
      mapStyle={heatMapStyle}
    >
      {
        loading &&
          <CircularProgress
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%'
            }}
          />
      }
      <Source type='geojson' data={dataMemo}>
        <Layer {...heatmapLayerPoints} />
        <Layer {...heatmapLayer} />
      </Source>
    </MapGL>
  );
};

export default HeatMap;
